// Dependencies
import jquery from 'jquery';
global.jQuery = jquery;
global.$ = jquery;
global.jquery = jquery;

window.Popper = require('popper.js').default;
require('bootstrap/dist/js/bootstrap.min.js');
require('select2/dist/js/select2');
require('jquery-validation/dist/jquery.validate');
require('bootstrap-select/dist/js/bootstrap-select.min.js');
if ($('body').data('locale') === 'bg' ) require('jquery-validation/dist/localization/messages_bg');
require('./plugins-config/easeScroll/jquery.easeScroll');
require('@fancyapps/fancybox/dist/jquery.fancybox');
window.toastr = require('toastr');
require('./scripts/cookies/jquery.cookiebar');

// Features
require('./plugins-config/plugins-config');
require('./scripts/mobile-nav/mobile-nav');
require('./scripts/main-nav/main-nav');
require('./scripts/login/login');
require('./scripts/filter-homepage/filter-homepage');
require('./scripts/swipers/swipers');
require('./scripts/forms-validation/forms-validation');
require('./scripts/zoom/zoom');
require('./scripts/cookies/cookies');
require('./scripts/toastr/toastr');
require('./scripts/modal/modal');
require('./scripts/save-to-favorites/save-to-favorites-global');

if ($('body').hasClass('page_map')) {
  require('./Vue/components/FilterComponents/filter-parent');
}
if ($('body').hasClass('body-profile')) {
  require('./Vue/components/UserProfile/user-profile');
}